import React, { useState, useRef } from "react"; // Combined imports
import emailjs from "@emailjs/browser";
import "../style/contactform.css";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    subject: "", // This is currently used for Phone Number
    email: "",
    message: "",
  });

  const form = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  //Sending email
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_3tb34sl", "template_e4fjqes", form.current, {
        publicKey: "_7KYa1vBqy83oA9r5",
      })
      .then(
        () => {
          alert("Email sent successfully!");

          setFormData({
            fullName: "",
            subject: "",
            email: "",
            message: "",
          });
        },
        (error) => {
          alert("Failed to send email. Please try again later.");
        },
      );
  };

  return (
    <div className="contact-container">
      <h2>Send us a Message</h2>
      <form ref={form} onSubmit={sendEmail} className="contact-form">
        <div className="contact-form-div1">
          <div className="contact-form-div1-items">
            <label>Full Name*</label>
            <input
              placeholder="Your full name"
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="contact-form-div1-items">
            <label>Email*</label>
            <input
              placeholder="your.email@example.com"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <label>Phone Number</label>
        <input
          placeholder="+44 xxxx xxx xxxx"
          type="text"
          name="subject"
          value={formData.subject}
          onChange={handleChange}
          required
        />

        <label>Message*</label>
        <textarea
          placeholder="Please tell us more about your needs or questions..."
          name="message"
          value={formData.message}
          onChange={handleChange}
          rows="5"
          required
        />

        <button type="submit" className="send-btn">
          Send Us Message
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
